import RowHeroWebEvent from "./RowHeroWebEvent";

export default class LocationChangedEvent extends RowHeroWebEvent {

  constructor(
    public pathName: string,
    public queryString: string) {
      super("LocationChangedEvent");
    }
}